import { render, staticRenderFns } from "./BookingDetailShorex.vue?vue&type=template&id=1256492d&scoped=true"
import script from "./BookingDetailShorex.vue?vue&type=script&lang=js"
export * from "./BookingDetailShorex.vue?vue&type=script&lang=js"
import style0 from "./BookingDetailShorex.vue?vue&type=style&index=0&id=1256492d&prod&lang=less&scoped=true"
import style1 from "./BookingDetailShorex.vue?vue&type=style&index=1&id=1256492d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1256492d",
  null
  
)

export default component.exports